import { CommonTypings as CommonTypingsDS } from '@sky-it-cmscomposer/liveblog-design-system';

interface IVendorConfigs {
    name: CommonTypingsDS.SocialType;
    id: string;
}

const cmpVendorsFallback = {
    instagram: { name: 'instagram', id: '6054c53ca228639c6f285121', type: 'custom', consent: false },
    facebook: { name: 'facebook', id: '5e7e1298b8e05c54a85c52d2', type: 'custom', consent: false },
    twitter: { name: 'twitter', id: '5e71760b69966540e4554f01', type: 'custom', consent: false },
    youtube: { name: 'youtube', id: '5e7ac3fae30e7d1bc1ebf5e8', type: 'custom', consent: false },
};

// @ts-ignore
const getCmpVendors = () => window?.SkyFoundationSettings?.cmpVendors || cmpVendorsFallback;
const getCmpVendorId = (vendorName: CommonTypingsDS.SocialType): string => getCmpVendors()[vendorName]?.id;

/**
 * name: vendor's name
 * id: used to trigger skyCMP changes
 */
export const vendorsConfigs: IVendorConfigs[] = [
    {
        name: 'instagram',
        id: getCmpVendorId('instagram'),
    },
    {
        name: 'facebook',
        id: getCmpVendorId('facebook'),
    },
    {
        name: 'twitter',
        id: getCmpVendorId('twitter'),
    },
    {
        name: 'youtube',
        id: getCmpVendorId('youtube'),
    },
];
